import PropTypes from 'prop-types';
import React from 'react';
import Link from 'next/link';
import Button from '@components/Shared/Buttons/Button';

import SidebarMain from './../SidebarMain';

import {
  SidebarWrapper,
  Header,
  NavPrevMobile,
  NavNextMobile,
  FooterDesktop,
  NavControls,
  NavNext,
  NavPrev,
  CtaLabel,
} from './Sidebar.styled';

class Sidebar extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.data !== nextProps.data) {
      return true;
    }

    if (this.props.started !== nextProps.started) {
      return true;
    }

    return false;
  }

  render() {
    const { data } = this.props;
    let isSafari = false;
    let isIOS = false;

    if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
      isSafari = !!navigator.userAgent.match(/Version\/[\d]+.*Safari/);
      isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }

    return (
      <SidebarWrapper
        className="sidebar"
        isIosSafari={isSafari && isIOS ? true : false}
      >
        <Header>
          {this.props.started && (
            <NavPrevMobile onClick={() => this.props.navigatePrev()}>
              &lt;
            </NavPrevMobile>
          )}
          <h2 id="header-title">{data ? data.title : 'Better by Design'}</h2>
          {this.props.started && (
            <NavNextMobile onClick={() => this.props.navigateNext()}>
              &gt;
            </NavNextMobile>
          )}
        </Header>

        <SidebarMain data={data} toggleDrawer={this.props.toggleDrawer} />

        <FooterDesktop className="footer-desktop">
          <NavControls className="nav-controls">
            {this.props.started && (
              <NavPrev onClick={() => this.props.navigatePrev()}>
                previous
              </NavPrev>
            )}
            {this.props.started && (
              <NavNext onClick={() => this.props.navigateNext()}>next</NavNext>
            )}
          </NavControls>

          <CtaLabel>Ready to see the real thing?</CtaLabel>

          <Button
            nextJSUrl="/locations/"
            linkComponent={Link}
            onButtonClick={() =>
              this.props.postTrackingEvent(
                'interactive floorplan',
                'cta click',
                'find a home center'
              )
            }
            automationId="ifp-home-center-button"
          >
            Find a Home Center
          </Button>

          <p className="disclaimer">
            * Not available in all homes. Please get in touch with your home
            consultant to discuss what upgrades are available for your home.
          </p>
        </FooterDesktop>
      </SidebarWrapper>
    );
  }
}

Sidebar.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.any,
  }),
  navigateNext: PropTypes.func,
  navigatePrev: PropTypes.func,
  postTrackingEvent: PropTypes.func,
  started: PropTypes.any,
  toggleDrawer: PropTypes.any,
};

export default Sidebar;
